import React, { Component } from "react";
import FilterElement from "Components/FilterElement";
import DashedButton from "Components/Button/DashedButton";
import RemoveIcon from "../icons/RemoveIcon";
import "./CustomQueueSorting.scss";

export class CustomQueueSorting extends Component {
  constructor(props) {
    super(props);

    let defaultSortCount = 1;

    this.state = {
      sortingMaxCount: this.props.sortingMaxCount,
      sortQueues: [],
      maxCountstate: true,
      sortInputVal: "",
      rowCountState: "",
      currentValues: {},
      rowCount: 1,
      addSortState: true,
      restrictCompUpdate: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.isUpdate && !this.state.restrictCompUpdate) {
      this.props.updateCustomQueueSortingVal(this.state.currentValues, this.state.sortQueues)
      this.setState((prevState) => ({
        restrictCompUpdate:true
      }));
    }
  }

  componentWillReceiveProps = (newProps) => {
    if (
      this.props.sortFilterList.length > 0
    ) {
      let updatedCurrentValue = newProps.sortFilterList.reduce((acc, curr) => {
        return (acc = { ...acc, [curr.elementId]: { v1: curr.v1 } });
      }, {});
      let getSortFilterList = [...this.props.sortFilterList];
      let updatedSortFilterList = getSortFilterList.map((obj) => {
        let index = obj.actualNameId.lastIndexOf("_");
        let rowCount = obj.actualNameId.substr(index + 1);
        let prefix = obj.actualNameId.replaceAll("_", " ");
        let elementLabel = this.capitalizeTheFirstLetterOfEachWord(prefix);
        return {
          ...obj,
          elementLabel: elementLabel.replace("Odr", "Order"),
          rowCount: rowCount,
          values: null,
          id: obj.actualNameId,
          elementCategoryName: "EXACT",
          elementTypeName: "DROPDOWN",
        };
      });

      updatedSortFilterList.sort(
        (a, b) => parseFloat(a.rowCount) - parseFloat(b.rowCount)
      );
      let rowCountState = this.props.sortFilterList.length / 2;
      this.setState((prevState) => ({
        currentValues: updatedCurrentValue,
        sortQueues: updatedSortFilterList,
        rowCount: rowCountState,
      }));
    }
  };

  capitalizeTheFirstLetterOfEachWord = (words) => {
    var separateWord = words.toLowerCase().split(" ");
    for (var i = 0; i < separateWord.length; i++) {
      separateWord[i] =
        separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1);
    }
    return separateWord.join(" ");
  };

  findDataAttribute(domNode) {
    if (domNode.getAttribute("data-name")) {
      return domNode.getAttribute("data-name");
    } else if (domNode.parentElement.getAttribute("data-name")) {
      return domNode.parentElement.getAttribute("data-name");
    } else if (domNode.parentElement.parentElement.getAttribute("data-name")) {
      return domNode.parentElement.parentElement.getAttribute("data-name");
    } else {
      return domNode.id;
    }
  }

  handledropdownValue = (sortInputId, sortInputVal) => {
    const currentValuesObj = this.state.currentValues;
    const targetLocation = `${sortInputId}.v1`;
    const pathArray = targetLocation.split(".");
    const lastNode = pathArray[pathArray.length - 1];
    let node = currentValuesObj;
    pathArray.forEach(
      (path, index) =>
        (node = index === pathArray.length - 1 ? node : node[path])
    );
    node[lastNode] = sortInputVal;
    this.setState((prevState) => ({
      currentValues: currentValuesObj,
    }), () => {this.props.updateCustomQueueSortingVal(this.state.currentValues, this.state.sortQueues)});
  };

  handleSelection = (value, event) => {
    event.stopPropagation();
    const sortInputId = this.findDataAttribute(event.target);

    const sortInputVal = value;

    let filterList = [...this.state.sortQueues];
    const searchInputObject = filterList.find((key) => key.id === sortInputId);

    let searchedInputVal = (searchInputObject.v1 = sortInputVal);

    this.handledropdownValue(sortInputId, sortInputVal);
  };

  addSortRows = () => {
    let rowCount = this.state.sortQueues.length / 2 + 1;
    let defaultSortValue = rowCount === 1 ? "cb" : (rowCount === 2 ? "rsncd" : "slacntr");

    this.setState({
      sortQueues: [
        ...this.state.sortQueues,
        {
          id: `sort_${rowCount}`,
          elementCategoryName: "EXACT",
          elementTypeName: "DROPDOWN",
          elementId: `sort_${rowCount}`,
          elementMandatory: true,
          updatedId: `sort_${rowCount}`,
          elementSection: "sort",
          actualNameId: `sort_${rowCount}`,
          elementLabel: `sort ${rowCount}`,
          name: `sort ${rowCount}`,
          values: null,
          category: "EXACT",
          elementType: "DROPDOWN",
          dropdownType: "sort",
          v1: defaultSortValue,
        },
        {
          id: `sort_odr_${rowCount}`,
          elementCategoryName: "EXACT",
          elementTypeName: "DROPDOWN",
          elementId: `sort_odr_${rowCount}`,
          elementMandatory: true,
          updatedId: `sort_odr_${rowCount}`,
          elementSection: "sort",
          actualNameId: `sort_odr_${rowCount}`,
          elementLabel: `Sort Order ${rowCount}`,
          name: `sort ${rowCount}`,
          values: null,
          category: "EXACT",
          elementType: "DROPDOWN",
          dropdownType: "sort_odr",
          v1: "ASC",
        },
      ],
      currentValues: {
        ...this.state.currentValues,
        [`sort_${rowCount}`]: { v1: defaultSortValue },
        [`sort_odr_${rowCount}`]: { v1: "ASC" },
      },
      rowCount: rowCount,
    }, () => {
      this.props.updateCustomQueueSortingVal(this.state.currentValues, this.state.sortQueues)
    });
  };

  removeSortRows = (count) => (e) => {
    let index = (count + 1) / 2;
    let removeSortQueuesArr = this.state.sortQueues.filter((sortedobj) => {
      return (
        sortedobj.actualNameId === `sort_${index}` ||
        sortedobj.actualNameId === `sort_odr_${index}`
      );
    });
    let sortQueues = this.state.sortQueues;
    let objToDeleteSet = new Set(removeSortQueuesArr);
    let updatedSortQueues = sortQueues.filter((reqArr) => {
      return !objToDeleteSet.has(reqArr);
    });
    let updatedRowCount = updatedSortQueues.length / 2;
    let firstIndex = 0;
    updatedSortQueues = updatedSortQueues
      .reverse()
      .map((updateSortQueue, index) => {
        if (index - firstIndex === 2) {
          firstIndex = index;
          updatedRowCount--;
        }
        let sortQueueId = updateSortQueue.actualNameId.substring(
          0,
          updateSortQueue.actualNameId.length - 1
        );
        let sortQueueLabel = updateSortQueue.elementLabel.substring(
          0,
          updateSortQueue.elementLabel.length - 1
        );
        updateSortQueue = {
          ...updateSortQueue,
          id: sortQueueId + updatedRowCount,
          actualNameId: sortQueueId + updatedRowCount,
          elementId: sortQueueId + updatedRowCount,
          updatedId: sortQueueId + updatedRowCount,
          elementLabel: sortQueueLabel + updatedRowCount,
          name: sortQueueId + updatedRowCount,
          rowCount: (sortQueueId + updatedRowCount).split("_").pop(),
        };
        return updateSortQueue;
      });
    updatedSortQueues.reverse();
    let updatedCurrentValue = updatedSortQueues.reduce((acc, curr) => {
      acc = { ...acc, [curr.id]: { v1: curr.v1 } };
      return acc;
    }, {});
    this.setState((prevState) => ({
      currentValues: updatedCurrentValue,
      sortQueues: updatedSortQueues,
      addSortState:
      this.state.rowCount <= this.state.sortingMaxCount,
      rowCount: updatedRowCount,
    }), () => {
      this.props.updateCustomQueueSortingVal(this.state.currentValues, this.state.sortQueues)
    });
  };

  displaySortListSelector = (buttonText) => {
    return (
      <div className="queue-container__cross-button">
        <div className="filter-input-container">
          {
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <DashedButton
                  extraClass="dashed-button-width"
                  action={() => {
                    this.addSortRows();
                  }}
                  style={{
                    width: "167%",
                    marginLeft: "15px",
                    marginTop: "-3px",
                    display:
                      this.state.addSortState &&
                      this.state.rowCount < this.state.sortingMaxCount &&
                      this.props.sortFilterList.length > 0
                        ? "block"
                        : "none",
                  }}
                >
                  {buttonText}
                </DashedButton>
              </div>
            </div>
          }
        </div>
      </div>
    );
  };

  displaySortFilterList(filter, index) {
    return (
      <FilterElement
        currentValues={this.state.currentValues[filter.elementId]}
        filter={
          filter.actualNameId.slice(0, filter.actualNameId.lastIndexOf("_")) ===
          "sort"
            ? { ...filter, filterValues: this.props.filterValuesState }
            : { ...filter, filterValues: this.props.filterValuesSortState }
        }
        handleSingleSelection={this.handleSelection}
        key={index}
        index={this.state.index}
      />
    );
  }

  render() {
    return (
      <div className="queue-container">
        <div className="queue-container__filters">
          {this.props.sortFilterList.map((queuesArr, index) => (
            <>
              {this.displaySortFilterList(queuesArr, index)}
              {index > 1 && index % 2 !== 0 ? (
                <div
                  role="button"
                  style={{ cursor: "pointer" }}
                  onClick={this.removeSortRows(index)}
                >
                  <RemoveIcon />
                </div>
              ) : (
                <div
                  role="button"
                  style={{ cursor: "pointer", visibility: "hidden" }}
                >
                  <RemoveIcon />
                </div>
              )}
            </>
          ))}
        </div>
        <div className="queue-container__add">
          {this.displaySortListSelector("+ Add Sort", true)}
        </div>
      </div>
    );
  }
}

export default CustomQueueSorting;